import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugDexlansoprazole} from "./TextDrugDexlansoprazole"


export default function Dexlansoprazole() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name='Dexlansoprazole' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Dexlansoprazole - PGx Recommendation"
        content={ <TextDrugDexlansoprazole />}

        />

</>
)}